// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cameras-table__camera-tooltip{background:#eee!important;border:1px solid #bbb;box-shadow:none!important}.cameras-table__camera-tooltip .snapshot-card__img{border-bottom:1px solid #bbb;box-shadow:none!important;box-sizing:content-box!important}.cameras-table__camera-tooltip__container{opacity:1!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
